import React from 'react';
import i18n from '../i18n';
import { Box } from '@material-ui/core';

import { LargeButton } from 'components/LargeButton/LargeButton';
import { LayoutFullHeightContainer } from 'components/Layout/LayoutFullHeightContainer';
import { LayoutGrowItem } from 'components/Layout/LayoutGrowItem';
import { LayoutFixedItem } from 'components/Layout/LayoutFixedItem';
import { Text, TextTypography } from 'components/Text/Text';

export const InitError = () => {
    const { t } = i18n.useTranslation();
    return (
        <LayoutFullHeightContainer>
            <LayoutGrowItem>
                <Box m={2}>
                    <Text typography={TextTypography.BODY}>{t('common:initError.description')}</Text>
                </Box>
            </LayoutGrowItem>
            <LayoutFixedItem>
                <Box m={2}>
                    <LargeButton onClick={() => window.location.reload()}>{t('common:initError.button')}</LargeButton>
                </Box>
            </LayoutFixedItem>
        </LayoutFullHeightContainer>
    );
};
